import { ERentioFormField } from "../../components/components/Form";
import { getName } from "../../redux/contact/contact.utils";
import { getValue, ibanSelectInlineValueSelector, } from "../../redux/form/form.utils";
import * as bankAccountActions from "../../reduxV2/bankAccount/bankAccount.actions";
import * as bankAccountSelectors from "../../reduxV2/bankAccount/bankAccount.selectors";
import { EExtraIbanSelectValues } from "../../types/contact.types";
import { EContractMemberTypes } from "../../types/contract.types";
import { formatDate } from "../../utils/date.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { formatCurrency } from "../../utils/number.utils";
import { EField } from "./schema.releaseRentDeposit.types";
import { getNavigationTitle, getTenants, } from "./schema.releaseRentDeposit.utils";
//Tenant bank account Ids
export var getSchema = function (initialValues, extraData) {
    return function (defaultValues) {
        var _a;
        return {
            required: [EField.TenantBankAccountId],
            properties: (_a = {},
                _a[EField.Header] = {
                    default: undefined,
                },
                _a[EField.Info] = {
                    default: undefined,
                },
                _a[EField.TenantBankAccountId] = {
                    default: getValue(EField.TenantBankAccountId, initialValues, defaultValues),
                },
                _a),
        };
    };
};
var getAccountId = function (formData, extraData) {
    var receiver = formData[EField.TenantReceiver];
    if (!receiver) {
        var tenantsAccounts = getTenants(extraData.relatedContract);
        return tenantsAccounts[0].id;
    }
    return receiver[0];
};
export var uiSchema = function (extraData) {
    var _a;
    var tenants = extraData.relatedContract.members.filter(function (member) {
        return member.roles.includes(EContractMemberTypes.Tenant) ||
            member.roles.includes(EContractMemberTypes.Parent);
    });
    var owners = extraData.relatedContract.members.filter(function (member) {
        return member.roles.includes(EContractMemberTypes.Owner);
    });
    var UNKNOWN_IBAN_LABEL = getLocalizedText("rent_deposit_release.tenant_bankaccount.unknown");
    return _a = {
            "rentio:title": getLocalizedText("rent_deposit_release.tenant_bankaccount.heading.summary"),
            "rentio:navigationTitle": getNavigationTitle(extraData)
        },
        _a[EField.Header] = {
            "ui:field": ERentioFormField.SectionHeader,
            title: getLocalizedText("rent_deposit_release.tenant_bankaccount.heading"),
        },
        _a[EField.Info] = {
            "ui:field": ERentioFormField.HelpInfo,
            title: getLocalizedText("rent_deposit_release.contract_info.heading"),
            subtitle: (function () {
                return getLocalizedText("rent_deposit_release.contract_info.content", {
                    startDate: formatDate(extraData.relatedContract.startDate),
                    amount: formatCurrency(extraData.relatedContract.amount || 0),
                    tenants: tenants.map(function (member) { return getName(member.account); }).join(", "),
                    owners: owners.map(function (member) { return getName(member.account); }).join(", "),
                });
            })(),
        },
        _a[EField.TenantBankAccountId] = {
            "ui:field": ERentioFormField.IbanSelectInline,
            title: getLocalizedText("rent_deposit_release.tenant_bankaccount.heading"),
            addIbanCtaTitle: getLocalizedText("iban.add.cta"),
            unknownIbanLabel: UNKNOWN_IBAN_LABEL,
            accountIdToAddIban: function (formData) { return getAccountId(formData, extraData); },
            getShowUnknownIbanOption: function (formData) { return !formData[EField.JudicialRelease]; },
            customUnknownIbanNotification: getLocalizedText("rent_deposit_release.tenant_bankaccount.unknown.message"),
            customIsFetchingSelector: function (state, formData) {
                return bankAccountSelectors.isFetchingContactBankAccounts(state, {
                    accountId: getAccountId(formData, extraData),
                });
            },
            customIbansSelector: function (state, formData) {
                return bankAccountSelectors.getContactBankAccounts(state, {
                    accountId: getAccountId(formData, extraData),
                });
            },
            customGetIbansActions: function (formData) { return [
                function () {
                    return bankAccountActions.getContactBankAccountsStart.getAction({
                        accountId: getAccountId(formData, extraData),
                    });
                },
            ]; },
            valueSelector: function (state, input) {
                if (input === EExtraIbanSelectValues.Unknown)
                    return UNKNOWN_IBAN_LABEL;
                return ibanSelectInlineValueSelector(state, input);
            },
        },
        _a;
};
export var getValidate = function () { return function (formData, errors) {
    if (!formData[EField.TenantBankAccountId]) {
        var noBankAccountError = getLocalizedText("rent_deposit_release.error.no_bank_account");
        errors[EField.TenantBankAccountId].addError(noBankAccountError);
    }
    return errors;
}; };
